import config from 'config';
import { authHeader } from '../_helpers';

export const accountService = {
    logout,
    getBookingOptions,
    setBookingOptions
};

function getBookingOptions(account) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(`${config.apiUrl}/customers/booking_options?account=` + account, requestOptions).then(handleResponse);
}

function setBookingOptions(bookingOptions) {
    var headers = authHeader();
    headers['Content-Type'] = 'application/json';
    const requestOptions = {
        crossDomain: true,
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bookingOptions)
    };

    var url = new URL(`${config.apiUrl}/customers/booking_options`);
    return fetch(url, requestOptions).then(handleResponse);
}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('token');
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                if(response.url !== `${config.apiUrl}/auth/login`)
                    location.reload(true);
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}